
    import {defineComponent, onMounted} from 'vue';
    import Dropdown3 from '@/components/dropdown/Dropdown3.vue';
    import Header from '@/components/siteComponents/Header.vue';
    import Footer from '@/components/siteComponents/Footer.vue';
    import {useStore} from "vuex";
    import {useRouter} from "vue-router";
    import {useI18n} from 'vue-i18n';

    export default defineComponent({
        name: 'profile',
        components: {
            Header,
            Footer,
            Dropdown3,
        },
        setup() {
            const store = useStore();
            const router = useRouter();

            onMounted(() => {
                //check if current user is authenticated
                if (!store.getters["moduleAuth/isUserAuthenticated"]) {
                    router.push({name: "login_page"});
                }
            })
        }
    });
